import usePriceDisplay from '@/app/components/hotel-detail/hooks/usePriceDisplay.ts';
import { usePriceModePreference } from '@/app/common/priceModeProvider.tsx';
import { useOffersContext } from '@/app/components/hotel-detail/OffersProvider';
import TotalPriceToggle from '@/app/common/components/TotalPriceToggle';

// The apex calendar's switch follows the same rule as the results page: it shows only where the
// toggler test can drive the funnel, and the calendar's own unit always follows the funnel's.
export function useTripOverviewPriceToggle() {
  const { canShowTotalPrice, showTotalPrice } = usePriceDisplay();
  const { setShowTotalPrice } = usePriceModePreference();

  return { showTotalPrice, setShowTotalPrice, showToggle: canShowTotalPrice };
}

// Callers gate on canShowTotalPrice, so the stored preference is always the one in play here and
// OffersProvider is guaranteed to be present.
export function TripOverviewPriceToggle({ className }: { className?: string }) {
  const { isLoadingRooms } = useOffersContext();
  return <TotalPriceToggle variant="row" disabled={isLoadingRooms} className={className} />;
}
